import React from 'react'
import PropTypes from 'prop-types'
import { UILayout } from 'bora-material-ui'
import { connect } from 'react-redux'
import ReactHtmlParser from 'react-html-parser'
import { compose, defaultTo, find, head, propOr, propEq } from 'ramda'
import { getLocale } from '../../../../services/user-selections'
import { getFirstPayedReservation } from '../../../../services/reservation/selectors'
import { getStyle } from '../../../../utils/liinilaevadThemeUtils'

const parseData = compose(head, ReactHtmlParser)

const styles = {
  termsContentWrapperXs: { width: '100%' },
}

const containerStyle = {
  marginTop: '2rem',
  paddingRight: getStyle('2.5rem'),
}

const ConditionsOfTicketsReturn = ({ mainTicketTermsContent, additionalTermsContent }) => (
  <UILayout
    column
    justify="space-around"
    data-testid="terms-container"
    margin={getStyle('0 20px')}
    padding="0px 0px 20px 0px"
    style={containerStyle}
  >
    <UILayout data-testid="main-ticket-terms-content" display-if={mainTicketTermsContent} width="100%">
      {mainTicketTermsContent}
    </UILayout>
    <UILayout padding="20px 0px 0px 0px" column center j-flex-center>
      <UILayout
        data-testid="additional-terms-content"
        display-if={additionalTermsContent}
        xs={styles.termsContentWrapperXs}
      >
        {additionalTermsContent}
      </UILayout>
    </UILayout>
  </UILayout>
)

ConditionsOfTicketsReturn.propTypes = {
  mainTicketTermsContent: PropTypes.string.isRequired,
  additionalTermsContent: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => {
  const locale = getLocale()(state)
  let reservation = getFirstPayedReservation(state)
  if (Object.keys(reservation).length === 0) {
    reservation = state.reservation.current
  }
  const searchTermByLang = compose(defaultTo({}), find(propEq('language', locale)), propOr([], 'terms'))
  const { ticketTerms = '', additionalTicketTerms = '' } = searchTermByLang(reservation)

  return {
    mainTicketTermsContent: parseData(`<div class="schedules">${ticketTerms}</div>`),
    additionalTermsContent: parseData(
      `<div class="schedules">${additionalTicketTerms.replace(/style=/gi, 'data-style=')}</div>`
    ),
  }
}

export default connect(mapStateToProps)(ConditionsOfTicketsReturn)
